import { apiFetch } from "../utils/api";

// Obtener todos los umbrales asociados a un dispositivo
export const getDeviceThresholds = async (deviceId) => {
  const res = await apiFetch(`/api/thresholds?deviceId=${deviceId}`);
  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    return { success: false, error: error?.message || "Error loading thresholds" };
  }
  const data = await res.json();
  return { success: true, data };
};

// Crear o actualizar un umbral
export const saveThreshold = async (deviceId, thresholdId, values) => {
  const method = thresholdId ? "PUT" : "POST";
  const url = thresholdId ? `/api/thresholds/${thresholdId}` : `/api/thresholds`;

  const payload = {
    deviceId,
    elementId: values.elementId,
    periodicityId: values.periodicityId,
    minValue: values.minValue,
    maxValue: values.maxValue
  };

  const res = await apiFetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    return { success: false, error: error?.message || "Error saving threshold" };
  }

  const data = await res.json();
  return { success: true, data };
};

// Eliminar un umbral por su ID
export const deleteThreshold = async (thresholdId) => {
  const res = await apiFetch(`/api/thresholds/${thresholdId}`, {
    method: "DELETE",
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    return { success: false, error: error?.message || "Error deleting threshold" };
  }

  return { success: true };
};
